import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import debounce from 'lodash/debounce';

import {modifyPageLayoutComponents} from '../PageLayout';
import {getSites, updateSite, saveSites, cancelSitesChanges, deleteSite} from './SitesActions';

import template from './Sites.rt';
// import SitesHeaderTemplate from './SitesHeader.rt';
import SitesFooterTemplate from '../../templates/PageLayout/GenericFooter.rt';
import {messageBox_Show} from '../../actions/A_Popups';
import SitesHeader from './SitesHeader';

const mapStateToProps = state => {
  let sites = [];
  if (state.sites.records) {
    sites = state.sites.records.toJS();
  }
  return {
    searchKeyword: state.sites.searchKeyword,
    sortKeyword: state.sites.sortKeyword,
    sites,
    totalPages: state.sites.totalPages,
    page: state.sites.page,
    statusUpdateSuccess: state.sites.statusUpdateSuccess,
    saveCount: sites.filter(site => site.changed).length
  }
};

const mapDispatchToProps = dispatch => ({
  dispatch,
  getSites: (page, searchKeyword, sortKeyword, order) => dispatch(getSites(page, searchKeyword, sortKeyword, order)),
  updateSite: (value, propName, site) => dispatch(updateSite(value, propName, site)),
  setSearchTerm: (value) => dispatch(getSites(0, value)),
  handleSaveClick: (e) => dispatch(saveSites()),
  handleCancelClick: (e) => dispatch(cancelSitesChanges()),
  deleteSite: site => dispatch(deleteSite(site))
});

class Sites extends Component {
  static propTypes = {
    sites: PropTypes.array,
    page: PropTypes.number,
    totalPages: PropTypes.number,
    getSites: PropTypes.func.isRequired,
    updateSite: PropTypes.func.isRequired,
    deleteSite: PropTypes.func.isRequired,
    searchKeyword: PropTypes.string
  };



  constructor() {
    super();

    this.state = {
      page: 0,
      activeUser: {},
      showDeletePopup: false,
      sortKeyword: '',
      focusedSiteIndex: null,
      sortOrder: ''
    };
  }

  componentDidMount() {
    this.props.getSites();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.statusUpdateSuccess) {
      this.props.getSites(this.st7ate.page, this.props.searchKeyword, this.state.sortKeyword, this.state.sortOrder);
    }
  }

  handlePaginate = (page) => {
    this.setState({page: page - 1});
    this.props.getSites(page - 1, this.props.searchKeyword, this.state.sortKeyword, this.state.sortOrder);
  };


  handleSortBy = (e, sortBy) => {
    const order = ((this.state.sortKeyword === sortBy) && this.state.sortOrder === 'asc') ? 'desc' : 'asc';
    this.setState({
      sortKeyword: sortBy,
      sortOrder: order,
      focusedSiteIndex: null
    });

    this.props.getSites(this.state.page, this.props.searchKeyword, sortBy, order);
  };

  handleInputChange = (e, site) => {
    const {value} = e.target;
    this.props.updateSite(value, 'subDomain', site);
  };

  toggleQuickQuoteEnabled = (site) => {
    const value = !site.enabled;
    this.props.updateSite(value, 'enabled', site);
  }

  toggleKitchenVisualizerEnabled = (site) => {
    const value = !site.kitchenVisualizerEnabled;
    this.props.updateSite(value, 'kitchenVisualizerEnabled', site);
  }

  handleDeleteSite = (site) => {
    this.props.dispatch(messageBox_Show(true, 'error', 'Delete Site',
      `Are you sure you want to delete the site ${site.fabricatorName + (site.subDomain ? '/' + site.subDomain : '')}?`,
      [{
        text: 'OK',
        onClick: () => {
          this.props.deleteSite(site);
          this.props.dispatch(messageBox_Show());
        }
      }, {
        text: 'Cancel',
        onClick: () => this.props.dispatch(messageBox_Show())
      }]));
  }

  render = template;
}

const connector = connect(mapStateToProps, mapDispatchToProps);

export const SitesLayoutComponents = modifyPageLayoutComponents({
  pageHeader: connector(SitesHeader),
  content: connector(Sites),
  pageFooter: connector(SitesFooterTemplate)
});

